<template>
  <div class="h5-search-header">
    <Icon
      class="h5-search-header__back"
      name="icon-arrow-left-l"
      @click="$router.back()"
    />
    <SearchInput
      class="h5-search-header__input"
      :model-value="defaultInput"
      placeholder="Search in factory"
      @click="onOpen"
      disabled
    />
    <Popup
      overlay-class="h5-search-header__popup"
      v-model:show="active"
      :animation="false"
      :style="{
        height: '100%',
        width: '100%'
      }"
      theme-color="#B0C7F5"
    >
      <div class="h5-search-header">
        <SearchInput
          ref="inputRef"
          class="h5-search-header__input"
          placeholder="Search in factory"
          :model-value="defaultInput"
          @clear="onSearch"
          @search="onSearch"
        />
        <div
          class="h5-search-header__cancel"
          @click="active = false"
        >
          Cancel
        </div>
      </div>
      <div class="h5-search-header__content">
        <Result
          :image="SearchImage"
          title="What do you want to ...?"
          sub-title="Enter the description, and let’s find your treasure!"
        />
      </div>
    </Popup>
  </div>
</template>

<script setup>
import { Icon } from '@/components/Icon'
import { Popup } from '@/components/Popup'
import { Result } from '@/components/Result'
import { SearchInput } from '@/components/SearchInput'
import SearchImage from '@/assets/result/search.svg'

defineProps({
  defaultInput: {
    type: String,
    default: null
  }
})

const emit = defineEmits(['search'])

const active = ref(false)

const inputRef = useTemplateRef('inputRef')

const onOpen = () => {
  active.value = true
  nextTick(() => {
    inputRef.value?.focus()
  })
}

const onSearch = (text) => {
  active.value = false
  emit('search', {
    text
  })
}
</script>

<style lang="less" scoped>
.h5-search-header {
  z-index: 2;
  position: sticky;
  top: 0;
  /** 修复部分机型顶部有白边问题 */
  margin-top: -1px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 6px 12px 14px;
  background-color: #B0C7F5;

  &__back {
    flex-shrink: 0;
    font-size: 24px;
  }

  &__input {
    height: 36px;

    :deep(.c-search-input__suffix) {
      font-size: 20px;
      background-color: #232323;
      color: white;
    }
  }

  &__cancel {
    font-family: mon-600;
    font-size: 12px;
    line-height: 16px;
    color: #232323;
  }

  :deep(&__popup) {
    background-color: #FFF;
    backdrop-filter: unset;
  }

  &__content {
    padding: 89px 0;
  }
}
</style>
